// extracted by extract-css-chunks-webpack-plugin
module.exports = {"icon-toggle-accordion":"_5PGX9","panel-header":"iKj4c","iconBlock":"teM87","panel":"kikmM","selected":"NPhuP"};